import update from './update';
import get from './get';

export default [update, get];
